var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('custom-table',{ref:"customTable",attrs:{"columns":_vm.columns,"custom-view":_vm.customView,"api-url":"/invoice-changed","table-height":"calc(100vh - 196px)"},on:{"showDialogProcess":_vm.showDialogProcess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }